import { useNavigate, useLocation, useParams } from 'react-router-dom';

export function withRouter(Component: any) {
    return function WrappedComponent(props: any) {
        const navigate = useNavigate();
        const location = useLocation();
        const params = useParams();
        return (
            <Component
                { ...props }
                navigate = { navigate }
        location = { location }
        params = { params }
        history = {{
            push: navigate,
                replace: (to: string) => navigate(to, { replace: true }),
                    goBack: () => navigate(-1)
        }
    }
        />
        );
};
}